export default {
  common: {
    systemNameSuffix: 'Intelligent Customer Service Management System', // Fixed suffix
    dashboard: 'Dashboard',
    confirm: 'Confirm',
    cancel: 'Cancel',
    submit: 'Submit',
    reset: 'Reset',
    search: 'Search',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    save: 'Save',
    back: 'Back',
    loading: 'Loading...',
    success: 'Operation successful',
    error: 'Operation failed',
    warning: 'Warning',
    info: 'Info',
    second: 's',
    actions: 'Actions',
    selectFile: 'Select File',
    refresh: 'Refresh',
    close: 'Close',
    description: 'Description'
  },
  login: {
    title: 'Welcome',
    subtitle: 'Please enter your username and password',
    username: 'Username',
    password: 'Password',
    usernamePlaceholder: 'Please enter username',
    passwordPlaceholder: 'Please enter password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    loginButton: 'Login',
    loggingIn: 'Logging in...',
    forgotPasswordTitle: 'Reset Password',
    forgotPasswordDesc: 'Please enter your username and email address, we will send a verification code to your email.',
    forgotPasswordStep2Desc: 'Please enter the verification code and new password',
    email: 'Email Address',
    emailPlaceholder: 'Please enter registered email',
    sendResetLink: 'Send Reset Link',
    sendVerifyCode: 'Send Verification Code',
    resendCode: 'Resend',
    resendAfter: 'Resend after {seconds} seconds',
    verifyCode: 'Verification Code',
    verifyCodePlaceholder: 'Please enter 6-digit verification code',
    icpLabel: 'ICP Filing: ',
    newPassword: 'New Password',
    newPasswordPlaceholder: 'Please enter new password (at least 6 characters)',
    confirmPassword: 'Confirm Password',
    confirmPasswordPlaceholder: 'Please enter new password again',
    resetPassword: 'Reset Password',
    resetting: 'Resetting...',
    sending: 'Sending...'
  },
  message: {
    loginSuccess: 'Login successful',
    loginFailed: 'Login failed',
    loginExpired: 'Login expired, please login again',
    sendFailed: 'Send failed',
    networkError: 'Network connection failed, please check your network',
    pleaseEnterUsername: 'Please enter username',
    pleaseEnterPassword: 'Please enter password',
    pleaseEnterEmail: 'Please enter email address',
    usernameOrPasswordError: 'Username or password error',
    accountLocked: 'Account is locked, please try again later',
    tenantNotFound: 'Tenant not found',
    accountOrEmailError: 'Account or email error',
    emailNotSet: 'This account has no email set, please contact administrator',
    emailSendFailed: 'Password has been reset, but email sending failed, please contact administrator',
    passwordResetSent: 'Password has been sent to your email',
    passwordResetSuccess: 'Password reset successful',
    pleaseFillAllFields: 'Please fill in all fields',
    passwordTooShort: 'Password must be at least 6 characters',
    passwordMismatch: 'New password and confirm password do not match',
    verifyCodeError: 'Verification code is incorrect or expired',
    verifyCodeRateLimit: 'Verification code sending frequency is too high, please try again later',
    verifyCodeSent: 'Verification code has been sent, please check your email'
  },
  menu: {
    dashboard: 'Dashboard',
    systemConfig: 'System Config',
    conversations: 'Conversations',
    feedbackRecords: 'Feedback Records',
    modelAnnotation: 'Model Annotation',
    modelTraining: 'Model Training',
    knowledgeBase: 'Knowledge Base',
    userManagement: 'User Management',
    systemPrompt: 'Prompt Settings',
    modelConfig: 'Model Config'
  },
  header: {
    logout: 'Logout',
    profile: 'Profile'
  },
  profile: {
    title: 'Personal Profile',
    titleRequired: 'Please Set Email',
    username: 'Account',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    email: 'Email',
    currentPasswordPlaceholder: 'Please enter current password for verification',
    newPasswordPlaceholder: 'Please enter new password',
    confirmPasswordPlaceholder: 'Please re-enter new password',
    emailPlaceholder: 'Please enter email address',
    save: 'Save',
    cancel: 'Cancel',
    saving: 'Saving...',
    currentPasswordRequired: 'Please enter current password',
    newPasswordRequired: 'Please enter new password',
    confirmPasswordRequired: 'Please re-enter new password',
    emailRequired: 'Please enter email address',
    passwordMinLength: 'Password must be at least 6 characters',
    passwordMismatch: 'New password and confirm password do not match',
    emailFormatError: 'Invalid email format',
    updateSuccess: 'Personal profile updated successfully',
    updateFailed: 'Personal profile update failed',
    // Specific error reasons
    errorCurrentPasswordWrong: 'Current password is incorrect',
    errorPasswordMismatch: 'New password and confirm password do not match',
    errorEmailFormat: 'Invalid email format',
    errorPasswordTooShort: 'Password must be at least 6 characters',
    errorNotOwnInfo: 'You can only modify your own information',
    errorNotLoggedIn: 'Not logged in or login expired',
    errorUpdateFailed: 'Update failed, please try again later',
    verifyCode: 'Verification Code',
    verifyCodePlaceholder: 'Please enter 6-digit verification code',
    sendVerifyCode: 'Send Verification Code',
    sendingVerifyCode: 'Sending...',
    verifyCodeSent: 'Verification code has been sent, please check your email',
    verifyCodeRequired: 'Please enter verification code',
    verifyCodeLength: 'Verification code must be 6 digits',
    verifyCodeError: 'Verification code is incorrect or expired',
    verifyCodeRateLimit: 'Verification code sending frequency is too high, please try again later',
    verifyCodeSendFailed: 'Failed to send verification code, please try again later',
    errorVerifyCodeError: 'Verification code is incorrect or expired',
    errorVerifyCodeRateLimit: 'Verification code sending frequency is too high, please try again later',
    errorVerifyCodeSendFailed: 'Failed to send verification code, please try again later',
    resendAfter: ' resend'
  },
  dashboard: {
    welcome: 'Welcome to Intelligent Customer Service Management System',
    totalConversations: 'Total Conversations',
    totalMessages: 'Total Messages',
    todayConversations: 'Today Conversations',
    todayMessages: 'Today Messages',
    dailyStatistics: 'Daily Statistics',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',
    last7DaysTrend: 'Last 7 Days Trend',
    last30DaysTrend: 'Last 30 Days Trend',
    conversationCount: 'Conversations',
    messageCount: 'Messages'
  },
  pages: {
    systemConfig: {
      description: 'Configure ASR, TTS, OpenAI, object storage and other system parameters',
      placeholder: 'System configuration page (under development)'
    },
    conversations: {
      description: 'View and manage all conversation records',
      placeholder: 'Conversations page (under development)'
    },
    modelAnnotation: {
      title: 'Model Annotation',
      description: 'Use Label Studio for data annotation. Annotated data can be used for model training'
    },
    modelTraining: {
      description: 'Upload annotated data to train custom models',
      placeholder: 'Model training page (under development)'
    },
    knowledgeBase: {
      description: 'Manage knowledge base documents',
      placeholder: 'Knowledge base management page (under development)'
    },
    userManagement: {
      description: 'Manage system user accounts',
      placeholder: 'User management page (under development)'
    },
    systemPrompt: {
      description: 'Configure prompts for AI conversation initial guidance',
      placeholder: 'Prompt settings page (under development)',
      promptEditor: 'Prompt Settings',
      promptHint: 'Prompts are used for initial guidance in AI conversations. You can use variable placeholders, such as {0} which represents knowledge base content. The system will automatically replace it with actual knowledge base information during conversations.',
      chatTest: 'Chat Test',
      promptPlaceholder: 'Please enter prompt template...',
      savePrompt: 'Save',
      saveSuccess: 'Prompt saved successfully',
      saveFailed: 'Failed to save prompt',
      loadFailed: 'Failed to load prompt',
      promptRequired: 'Prompt cannot be empty',
      chatPlaceholder: 'Chat test feature under development...',
      inputPlaceholder: 'Please enter a message...',
      send: 'Send',
      chatFailed: 'Chat failed, please try again later'
    }
  },
  systemConfig: {
    companyInfo: 'Company Information',
    companyNameCn: 'Company Abbreviation',
    companyNameCnPlaceholder: 'Please enter company abbreviation (Chinese)',
    companyNameCnRequired: 'Please enter company abbreviation (Chinese)',
    companyNameEn: 'Company Abbreviation',
    companyNameEnPlaceholder: 'Please enter company abbreviation (English)',
    companyNameEnRequired: 'Please enter company abbreviation (English)',
    companyFullNameCn: 'Company Full Name (Chinese)',
    companyFullNameCnPlaceholder: 'Please enter company full name (Chinese), used for user agreement and privacy policy signature',
    companyFullNameCnRequired: 'Please enter company full name (Chinese)',
    companyFullNameEn: 'Company Full Name (English)',
    companyFullNameEnPlaceholder: 'Please enter company full name (English), used for user agreement and privacy policy signature',
    companyFullNameEnRequired: 'Please enter company full name (English)',
    adminDomain: 'Admin Domain',
    adminDomainRequired: 'Admin domain cannot be empty',
    clientDomain: 'Client Domain',
    clientDomainRequired: 'Client domain cannot be empty',
    wikiDomain: 'Wiki Domain',
    wikiDomainRequired: 'Wiki domain cannot be empty',
    companyLogoUrl: 'Admin Cover Image',
    companyLogoUrlPlaceholder: 'Please enter admin cover image URL',
    companyLogoUrlRequired: 'Please enter admin cover image URL',
    companyLogo: 'Company Logo',
    companyLogoPlaceholder: 'Please enter company logo URL',
    companyLogoRequired: 'Please enter company logo URL',
    uploadImage: 'Click to Upload',
    uploadImageButton: 'Upload Image',
    imageUploading: 'Uploading...',
    imageUploadSuccess: 'Image uploaded successfully',
    imageUploadFailed: 'Image upload failed',
    imageUploadError: 'Image upload failed, please try again',
    imageTypeError: 'Only image files are allowed!',
    imageSizeError: 'Image size cannot exceed 5MB!',
    coverImageUploadSuccess: 'Cover image uploaded successfully',
    logoUploadSuccess: 'Logo uploaded successfully',
    imagePreview: 'Image Preview',
    reUpload: 'Re-upload',
    clickToUpload: 'Click to upload image',
    icpNumber: 'ICP Filing Number',
    icpNumberPlaceholder: 'Please enter ICP filing number (e.g., 京ICP备12345678号)',
    speechConfig: 'Speech Configuration (ASR/TTS)',
    speechConfigDesc: 'ASR (Speech Recognition) and TTS (Text-to-Speech) share the following configuration',
    testAsr: 'Test ASR',
    testTts: 'Test TTS',
    storageConfig: 'Object Storage Configuration',
    modelConfig: 'Model Settings',
    modelConfigDesc: 'Self-deployed model name is recommended to use company English abbreviation, e.g.: JC_AI',
    selectDeployedModel: 'Select Deployed Model',
    selectDeployedModelPlaceholder: 'Please select a deployed model',
    azureSpeechKey: 'Azure Speech API Key',
    azureSpeechKeyPlaceholder: 'Please enter Azure Speech API Key',
    azureSpeechKeyRequired: 'Please enter Azure Speech API Key',
    azureSpeechEndpoint: 'Azure Speech Endpoint',
    azureSpeechEndpointPlaceholder: 'Please enter Azure Speech endpoint (e.g., https://westus2.api.cognitive.microsoft.com/)',
    azureSpeechEndpointRequired: 'Please enter Azure Speech endpoint',
    azureSpeechRegion: 'Azure Speech Region',
    azureSpeechRegionPlaceholder: 'Please enter Azure Speech region (e.g., westus2)',
    azureSpeechRegionRequired: 'Please enter Azure Speech region',
    azureStorageEndpoint: 'Azure Storage Endpoint',
    azureStorageEndpointPlaceholder: 'Please enter Azure storage endpoint (e.g., https://jcaistorage.blob.core.windows.net)',
    azureStorageEndpointRequired: 'Please enter Azure storage endpoint',
    azureStorageAccountName: 'Azure Storage Account Name',
    azureStorageAccountNamePlaceholder: 'Please enter Azure storage account name',
    azureStorageAccountNameRequired: 'Please enter Azure storage account name',
    azureStorageAccountKey: 'Azure Storage Account Key',
    azureStorageAccountKeyPlaceholder: 'Please enter Azure storage account key',
    azureStorageAccountKeyRequired: 'Please enter Azure storage account key',
    azureOpenaiDeploymentName: 'Azure OpenAI Deployment Name',
    azureOpenaiDeploymentNamePlaceholder: 'Please enter Azure OpenAI deployment name (e.g., gpt-4o)',
    azureOpenaiDeploymentNameRequired: 'Please enter Azure OpenAI deployment name',
    azureOpenaiApiBase: 'Azure OpenAI API Base',
    azureOpenaiApiBasePlaceholder: 'Please enter Azure OpenAI API domain (e.g., https://jcaiserver-openai.openai.azure.com/)',
    azureOpenaiApiBaseRequired: 'Please enter Azure OpenAI API Base',
    azureOpenaiApiKey: 'Azure OpenAI API Key',
    azureOpenaiApiKeyPlaceholder: 'Please enter Azure OpenAI API Key',
    azureOpenaiApiKeyRequired: 'Please enter Azure OpenAI API Key',
    azureOpenaiApiVersion: 'Azure OpenAI API Version',
    azureOpenaiApiVersionPlaceholder: 'Please enter Azure OpenAI API version (e.g., 2024-12-01-preview)',
    azureOpenaiApiVersionRequired: 'Please enter Azure OpenAI API version',
    azureOpenaiBaseModelName: 'OpenAI Base Model Name',
    azureOpenaiBaseModelNamePlaceholder: 'Please enter OpenAI base model name (e.g., gpt-4o)',
    azureOpenaiBaseModelNameRequired: 'Please enter OpenAI base model name',
    test: 'Test',
    save: 'Save',
    saving: 'Saving...',
    loadFailed: 'Failed to load configuration',
    saveSuccess: 'Configuration saved successfully',
    saveFailed: 'Failed to save configuration',
    configTestFailed: 'Configuration test failed',
    pleaseFillAsrConfig: 'Please fill in ASR configuration first',
    pleaseFillTtsConfig: 'Please fill in TTS configuration first',
    pleaseFillStorageConfig: 'Please fill in object storage configuration first',
    asrTestSuccess: 'ASR test successful',
    asrTestFailed: 'ASR test failed',
    asrConfigError: 'ASR configuration error, please check Azure Speech API Key and Azure Speech configuration',
    ttsTestSuccess: 'TTS test successful',
    ttsTestFailed: 'TTS test failed',
    ttsConfigError: 'TTS configuration error, please check Azure Speech API Key and Azure Speech configuration',
    storageTestSuccess: 'Object storage test successful',
    storageTestFailed: 'Object storage test failed',
    storageConfigError: 'Object storage configuration error, please check Azure Storage configuration',
    testModel: 'Deploy Model',
    modelTestSuccess: 'Model deployment successful',
    modelTestFailed: 'Model deployment failed',
    modelConfigError: 'Model configuration error, please check Azure OpenAI configuration',
    modelTestNotPassed: 'Please complete model deployment and ensure it passes',
    pleaseFillModelConfig: 'Please fill in complete model configuration information',
    useJiecangConfig: 'Use Jiecang Config',
    ownConfig: 'Own Config',
    useJiecangDeployment: 'Use Jiecang Model',
    ownDeployment: 'Own Deployment',
    jiecangConfigTip: 'Currently using Jiecang config, no need to fill in or test',
    jiecangDeploymentTip: 'Currently using Jiecang model, no need to fill in or test',
    asrTestNotPassed: 'Please complete ASR test and ensure it passes',
    ttsTestNotPassed: 'Please complete TTS test and ensure it passes',
    storageTestNotPassed: 'Please complete object storage test and ensure it passes',
    // Wiki Knowledge Base Configuration
    wikiKnowledgeBase: 'Wiki Knowledge Base',
    wikiKbMode: 'Knowledge Base Import Mode',
    wikiKbModeAll: 'All Pages',
    wikiKbModeTags: 'Specified Tags',
    wikiKbTags: 'Tags',
    wikiKbTagsDesc: 'For example: company, product, after-sales (maximum 10 tags)',
    wikiKbTagPlaceholder: 'Please enter tag name',
    addTag: 'Add Tag',
    wikiKbTagsTip: 'Current {count} tags, maximum {max} tags',
    wikiKbTagsRequired: 'Please add at least one tag',
    wikiKbTagsMaxLimit: 'Maximum 10 tags allowed',
    wikiKbTagsNotEmpty: 'Tag cannot be empty',
    wikiKbTagsNoDuplicate: 'Tags cannot be duplicated'
  },
    modelConfig: {
    title: 'Model Configuration',
    description: 'Configure and manage AI model related settings',
    placeholder: 'Model configuration page (under development)'
  },
  conversations: {
    dateRange: 'Date Range',
    rangeSeparator: 'to',
    startDate: 'Start Date',
    endDate: 'End Date',
    status: 'Status',
    statusAll: 'All',
    statusActive: 'Active',
    statusExpired: 'Expired',
    search: 'Search',
    searchPlaceholder: 'Enter conversation ID or IP address',
    conversationId: 'Conversation ID',
    ipAddress: 'IP Address',
    location: 'Location',
    messageCount: 'Messages',
    createdAt: 'Created At',
    lastAccessTime: 'Last Access',
    viewDetail: 'View Detail',
    detailTitle: 'Conversation Detail',
    messages: 'Messages',
    userMessage: 'User Message',
    aiResponse: 'AI Response',
    audioMessage: 'Audio Message',
    success: 'Success',
    failed: 'Failed',
    liked: 'Liked',
    disliked: 'Disliked',
    dislikeReason: 'Dislike Reason',
    dislikeDetail: 'Details',
    dislikeOption1: 'Answer is inaccurate',
    dislikeOption2: 'Not helpful',
    dislikeOption4: 'Other',
    dislikeOptionUnknown: 'Unknown',
    noMessages: 'No messages',
    expand: 'Expand',
    collapse: 'Collapse',
    audioNotSupported: 'Your browser does not support audio playback',
    unknownMessageType: 'Unknown message type'
  },
  feedbackRecords: {
    title: 'Feedback Records',
    description: 'View user feedback on AI responses',
    conversationId: 'Conversation ID',
    answerTime: 'Answer Time',
    questionContent: 'Question Content',
    answerContent: 'Answer Content',
    feedbackStatus: 'Feedback Status',
    feedbackCategory: 'Feedback Category',
    dislikeReason: 'Dislike Reason',
    actions: 'Actions',
    liked: 'Liked',
    disliked: 'Disliked',
    feedbackCategory1: 'Answer is inaccurate',
    feedbackCategory2: 'Not helpful',
    feedbackCategory3: 'Contact Support',
    feedbackCategory4: 'Other',
    feedbackCategoryUnknown: 'Unknown',
    viewDetail: 'View Detail',
    viewConversation: 'View Q&A Record',
    searchPlaceholder: 'Enter conversation ID',
    noData: 'No feedback records',
    dateRange: 'Date Range',
    rangeSeparator: 'to',
    startDate: 'Start Date',
    endDate: 'End Date',
    search: 'Search',
    reset: 'Reset',
    loading: 'Loading...',
    questionTypeImage: '[Image]',
    questionTypeAudio: '[Audio]',
    download: 'Download',
    exportSuccess: 'Export successful',
    exportFailed: 'Export failed'
  },
  modelTraining: {
    title: 'Model Training',
    description: 'Upload annotated ZIP file, the system will automatically train and deploy the model',
    currentModel: {
      title: 'Current Model',
      modelName: 'Model Name',
      modelId: 'Model ID',
      deployedAt: 'Deployed At',
      modelPath: 'Model Path',
      defaultModel: 'Default Model (Jiecang)',
      notDeployed: 'Not Deployed',
      switchToDefault: 'Switch to Jiecang Default Model',
      switchToDefaultConfirm: 'Are you sure you want to switch to the Jiecang default model? The currently deployed custom model will be undeployed.',
      switchToDefaultSuccess: 'Switched to default model successfully',
      switchToDefaultFailed: 'Failed to switch to default model'
    },
    upload: {
      title: 'Upload Dataset',
      dragText: 'Click or drag ZIP file here to upload',
      hint: 'Support YOLO format ZIP file exported from Label Studio, max 500MB',
      uploading: 'Uploading...',
      fileTypeError: 'Only ZIP files are allowed',
      fileSizeError: 'File size cannot exceed 500MB',
      uploadSuccess: 'Upload successful, training started',
      uploadFailed: 'Upload failed'
    },
    tasks: {
      title: 'Training Tasks',
      taskId: 'Task ID',
      fileName: 'File Name',
      status: 'Status',
      progress: 'Progress',
      trainingStartTime: 'Training Start Time',
      trainingEndTime: 'Training End Time',
      createdAt: 'Created At',
      actions: 'Actions',
      test: 'Test',
      deploy: 'Deploy',
      download: 'Download',
      delete: 'Delete',
      viewError: 'View Error',
      refresh: 'Refresh',
      training: 'Training...',
      waiting: 'Waiting...',
      downloading: 'Downloading model...',
      downloadSuccess: 'Download successful',
      downloadFailed: 'Download failed',
      cannotDeleteDeployed: 'Deployed models cannot be deleted. Please undeploy first.',
      deleteConfirm: 'Are you sure you want to delete this task? This operation cannot be undone.',
      deleteSuccess: 'Delete successful',
      deleteFailed: 'Delete failed'
    },
    status: {
      pending: 'Pending',
      training: 'Training',
      completed: 'Completed',
      failed: 'Failed',
      unknown: 'Unknown',
      deployed: '✅ Deployed'
    },
    test: {
      title: 'Test Model',
      uploadImage: 'Upload Test Image',
      recognizing: 'Recognizing...',
      recognized: 'Recognition completed',
      testFailed: 'Test failed',
      imageOnly: 'Only image files are allowed',
      detected: 'Detected',
      notDetected: 'No target detected',
      result: 'Recognition Result',
      predictions: 'All Predictions',
      category: 'Category',
      confidence: 'Confidence'
    },
    deploy: {
      title: 'Deploy Model',
      taskId: 'Task ID',
      fileName: 'File Name',
      modelPath: 'Model Path',
      hint: 'After deployment, the system will use this model for image recognition. The model file has been automatically downloaded to the server.',
      warning: 'Note: There is already a deployed model. Deploying a new model will replace the current one.',
      confirm: 'Confirm Deploy',
      cancel: 'Cancel',
      deploying: 'Deploying...',
      deploySuccess: 'Deploy successful',
      deployFailed: 'Deploy failed'
    },
    error: {
      title: 'Training Error',
      details: 'Error Details'
    }
  }
}

